var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAcademia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#333;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49.89566,25.46216l-25.31561,13.72754v4.72949l8.00671,4.74261v16.44342l17.51758,9.43262,17.25983-9.35938v-16.53796l4.02649-2.36816v16.70007l4.0293-2.18506v-21.58105l-25.52429-13.74414Zm13.43921,33.85437l-16.45172,8.92114-10.26709-5.52869v-11.66052l13.2796,7.86584,13.43921-7.90405v8.30627Zm-13.39862-7.00024l-18.10754-9.01013,21.2973-11.54858,18.16846,9.83405-21.35822,10.72467Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcademia);
export default __webpack_public_path__ + "static/media/icon_academia.5a3949ddfee6720e8054d6a5f57a5f78.svg";
export { ForwardRef as ReactComponent };